/**
 * useFaqSchema — injects a FAQPage JSON-LD script into <head> for AEO.
 * Call once per service page with the page's FAQ pairs.
 * Automatically removes the script on unmount.
 */
import { useEffect } from "react";

export interface FaqItem {
  question: string;
  answer: string;
}

export function useFaqSchema(faqs: FaqItem[], id: string) {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.appendChild(document.createTextNode(JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answer,
        },
      })),
    })));
    document.head.appendChild(script);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, []);
}
